var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin67007Bf547(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5005 0.5C5.87299 0.5 0.500488 5.8725 0.500488 12.5C0.500488 19.1275 5.87299 24.5 12.5005 24.5C19.128 24.5 24.5005 19.1275 24.5005 12.5C24.5005 5.8725 19.128 0.5 12.5005 0.5ZM9.56299 17.4738H7.13299V9.65375H9.56299V17.4738ZM8.33299 8.69375C7.56549 8.69375 7.06924 8.15 7.06924 7.4775C7.06924 6.79125 7.58049 6.26375 8.36424 6.26375C9.14799 6.26375 9.62799 6.79125 9.64299 7.4775C9.64299 8.15 9.14799 8.69375 8.33299 8.69375ZM18.438 17.4738H16.008V13.14C16.008 12.1313 15.6555 11.4462 14.7767 11.4462C14.1055 11.4462 13.7067 11.91 13.5305 12.3563C13.4655 12.515 13.4492 12.74 13.4492 12.9638V17.4725H11.018V12.1475C11.018 11.1713 10.9867 10.355 10.9542 9.6525H13.0655L13.1767 10.7388H13.2255C13.5455 10.2288 14.3292 9.47625 15.6405 9.47625C17.2392 9.47625 18.438 10.5475 18.438 12.85V17.4738Z",
    fill: "#F1F6FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin67007Bf547);
export default __webpack_public_path__ + "static/media/icon_linkedin_67007bf547.4709973979f4b00a31c0be93be1c35b7.svg";
export { ForwardRef as ReactComponent };